import { render, staticRenderFns } from "./CommonFooterJa.vue?vue&type=template&id=676b5ec5&scoped=true&"
import script from "./CommonFooterJa.vue?vue&type=script&lang=ts&"
export * from "./CommonFooterJa.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFooterJa.vue?vue&type=style&index=0&id=676b5ec5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b5ec5",
  null
  
)

export default component.exports